<template>
  <div>
    <div v-if="show">
      <div class="img-back-container">
        <img src="https://a1.wanwanshequ.com/static/public/ec5e7576698d1808.png"/>
      </div>
      <div class="install-guide" id="animate">
        <img src="https://a1.wanwanshequ.com/static/public/1c0871da72e1d353.png"/>
      </div>
    </div>
    <div v-if="showNeedSafari">
      <div class="show-safari-tip">
        <div class="txt">
          请使用 Safari 浏览器打开
        </div>
      </div>
    </div>
    <div v-if="showContentWarning">
      <div class="show-safari-tip">
        <div class="txt">
          网页中包含🌈同志相关主题内容，确实进入？
        </div>
        <div class="btn-container">
          <Button @click="onEnter" class="btn" type="warning">进入</Button>
          <Button class="btn">关闭</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Button} from "vant"
  export default {
    name: "DownloadGuideIos",
    components: {Button},
    data() {
      return {
        show: false,
        showNeedSafari: false,
        showContentWarning: false,
      }
    },
    mounted() {
      if (window.navigator.standalone) {
        return
      }

      if (this.isIos()) {
        if (this.isSafari()) {
          this.show = true
          setTimeout(() => {
            this.move()
          }, 2000)
        } else {
          this.showNeedSafari = true
        }
      } else {
        let agree = this.$store.getters.getContentWarningTip
        if (!agree) {
          this.showContentWarning = true
        }

      }
    },
    methods: {
      isIos() {
        let ua = window.navigator.userAgent;
        let macOs =  ua.indexOf('Mac OS X') !== -1
        let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i) || macOs;
        return iOS
      },

      isSafari() {
        let issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        return issafariBrowser
      },

      onEnter() {
        this.$store.dispatch("SetContentWarningTip", true)
        this.showContentWarning = false
      },

      move() {
        let elem = document.getElementById("animate");
        let step = 1;
        let stepSum = 0
        let posBase = 10
        let id = setInterval(frame, 100);

        function frame() {
          if (stepSum >= 15) {
            step = -1.2
          } else if (stepSum <= 0) {
            step = 1.2
          }
          stepSum += step
          elem.style.bottom = posBase + stepSum + 'px';
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  .img-back-container {
    position: fixed;
    top: 0;
    z-index: 10000;
    background: #fef951;
    min-height: 100vh;

    img {
      width: 100%;
    }
  }

  .install-guide {
    z-index: 10001;
    position: fixed;
    bottom: 25px;

    img {
      width: 100%;
    }
  }

  .show-safari-tip {
    height: 100vh;
    background: #f2f2f2;
    z-index: 10000;
    position: fixed;
    top: 0;
    text-align: center;
    width: 100%;

    .txt {
      padding: 64px 38px;
      line-height: 1.5;
      font-size: 28px;
      color: #000;
    }
  }

  .btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .btn {
      margin-top: 22px;
      width: 70%;
    }
  }
</style>
